
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ws-test",
      function () {
        return require("private-next-pages/ws-test/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ws-test"])
      });
    }
  